import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {createStore ,applyMiddleware} from 'redux';
import createSagaMiddleWare from 'redux-saga';
import {Provider} from 'react-redux';
import allReducers from "./reducers/index";
import allSagas from "./saga/index";
import { composeWithDevTools } from 'redux-devtools-extension';
import {myFriends,myPlaces,removeDuplicates} from './config/global-functions';
import {ErrorBoundary} from "./containers/Error/errorboundary";
const sagaMiddleWare = createSagaMiddleWare();



const getStore=()=>{
	
	try
	{
		const store_ = JSON.parse(localStorage.getItem("store"));

		return store_;
	}
	catch(err)
	{
		console.log(err);
		
		return null;
	}
}

const keyStore = getStore()||{};

const store = createStore(
                            allReducers,keyStore,
                            composeWithDevTools(applyMiddleware(sagaMiddleWare))
						);

sagaMiddleWare.run(allSagas);

const save=async()=>{

		localStorage.setItem("store",JSON.stringify(store.getState()));	
		localStorage.setItem("myFriends",JSON.stringify(myFriends(store.getState())));
		localStorage.setItem("myPlaces",JSON.stringify(myPlaces(store.getState())));
		
		var cGroups = store.getState().cryodexGroups;
		
		localStorage.setItem("cryodexGroups",JSON.stringify(cGroups));
		
		if(cGroups.data)
		{
			if(cGroups.data[0])
			{
				localStorage.setItem("cryodexDefaultGroupId",cGroups.data[0][0]?cGroups.data[0][0].Cryodex_Group_ID:"");
			}
		
		}
			  
		  var i;
		  
		  var crydNotInGroups = [];
		  
		  if(cGroups.data)
		 {
			  
			  for(i=1; i<cGroups.data.length ; i++)
			  {
				  if(cGroups.data[i])
				  {
					  if(cGroups.data[i])
					  {
						 if(cGroups.data[i].length > 0)
						 {	
							 var j;
							 
							 if(cGroups.data[i])
							 {
							 
								 for(j=0; j < cGroups.data[i].length; j++)
								 {
									 if(cGroups.data[i][j].cryodexes)
									 {
										if(cGroups.data[i][j].cryodexes.length > 0)
										{
											var x ;
											
											if(cGroups.data[i][0].cryodexes)
											{
											
												for(x=0; x<cGroups.data[i][0].cryodexes.length ;x++)
												{
													crydNotInGroups.push(cGroups.data[i][0].cryodexes[x]);
												}
											}
										}
									 }
								 }
							 }
							 
						 }
					  }
				  }
			  }
		 }
		  
		  localStorage.setItem("cryodexesNotInDefaultGroup",JSON.stringify(crydNotInGroups));
		  
		  var mailFriends = store.getState().mailbox.data;
		  
		  var friendsInGroups = JSON.parse(localStorage.getItem("gF"));
		  
		  var mailObject = {Cryodex_ID:"",Username:"",ImageSource:""};
		  
		  var mailLeftOutFriends = [];
		  
		  var mailFriendsAcceptedMyInvite = [];
		  
		  var x ;
		  
		  if(mailFriends)
		  {
						
			for(x=0; x<mailFriends.length ;x++)
			{
				var i ;
				
				var found = false;
				
				if(friendsInGroups)
				{
								
					for(i=0; i<friendsInGroups.length; i++)
					{
					
						if(
							((mailFriends[x].To_Cryodex_ID == friendsInGroups[i].Cryodex_ID) &&
							(mailFriends[x].Status == "ACCEPTED"))
						)
						{
							found = true;
							
							break;
						}
						else if
							((mailFriends[x].From_Cryodex_ID == friendsInGroups[i].Cryodex_ID) &&
							(mailFriends[x].Status == "ACCEPTED"))					
						{
							
							mailObject.Cryodex_ID = mailFriends[x].from_user.Cryodex_ID;
							mailObject.Username = mailFriends[x].from_user.Username;
							mailObject.ImageSource = mailFriends[x].from_user.ImageSource;
							mailFriendsAcceptedMyInvite.push(mailObject);
							
							break;
							found = true;
						}
						
					}
				}
				if(!found && (mailFriends[x].Status == "ACCEPTED"))
				{
					mailObject.Cryodex_ID = mailFriends[x].from_user.Cryodex_ID;
					mailObject.Username = mailFriends[x].from_user.Username;
					mailObject.ImageSource = mailFriends[x].from_user.ImageSource;
					mailLeftOutFriends.push(mailObject);

				}				
				
			}
		  }
			 var mailFriendsMerged = removeDuplicates(mailLeftOutFriends.concat(mailFriendsAcceptedMyInvite));
			 			 
			 
			 var j;
			 
			 if(mailLeftOutFriends)
			 {
			 
				  for(j=0; j < mailLeftOutFriends.length; j++)
				 {
					 
					 if(mailLeftOutFriends[j])
					 {
						if(mailLeftOutFriends[j].length > 0)
						{
							var x ;
							
							var found = false;
							
							if(mailFriendsAcceptedMyInvite)
							{
							
								for(x=0; x<mailFriendsAcceptedMyInvite.length ;x++)
								{
									if(mailLeftOutFriends[j].Cryodex_ID == mailFriendsAcceptedMyInvite[x].Cryodex_ID)
									{
										found = true;
										break;
									}
								}
								if(!found)
								{
									mailFriendsMerged.push(mailLeftOutFriends[j]);
								}
							}
						}
					 }
				 }
			 }
			
			 localStorage.setItem("mailBoxFriends",JSON.stringify(mailLeftOutFriends));
			 
			 localStorage.setItem("mailBoxFriendsInvited",JSON.stringify(mailFriendsAcceptedMyInvite));
			 
			 localStorage.setItem("mailFriendsMerged",JSON.stringify(mailFriendsMerged));
			 
			 return true;
		  		
	
}

store.subscribe(() => {var returnBool = save()});

ReactDOM.render(
   
<Provider store={store}> 
		
            <App />
				
</Provider>			
    
, document.getElementById('root'));


